import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import Spinner from '../../../components/common/Spinner';
import { FlexCenter } from '../../../styles/stylesStyled';
import { Info, InfoRight, Subtitle, Title } from './WithdrawStyled';

import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../app/hooks';
import { CheckText } from '../../../components/common/CheckText';
import { ULX } from '../../../helpers/helperFunctions';
import { P3 } from '../../../styles/FontStyles';
import { Button, SectionSeparator } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { WithdrawSteps, WithdrawAvailability } from '../Portfolio.types';
import { UserWalletModel } from '../../../types/wallets-types';

interface WithdrawFinalCheckProps {
  setStep: Dispatch<SetStateAction<WithdrawSteps>>;
  amount: string;
  selected: number;
  userWallets: UserWalletModel[];
  withdrawAvailabilitySteps: number;
}

export const WithdrawFinalCheck = ({
  setStep,
  amount,
  selected,
  userWallets,
  withdrawAvailabilitySteps
}: WithdrawFinalCheckProps) => {
  const { t } = useTranslation('earnings');
  const [checkbox, setCheckbox] = useState(false);
  const [total, setTotal] = useState(0);

  const fee =
    withdrawAvailabilitySteps === WithdrawAvailability.ULX
      ? Math.max(
          1,
          Number.parseFloat(((7.5 / 100) * Number(amount)).toFixed(2))
        )
      : Math.max(
          1,
          Number.parseFloat(((3.5 / 100) * Number(amount)).toFixed(2))
        );

  const amountToCalculate = amount;

  const calculatedAmountWithFee = Number.parseFloat(amountToCalculate) - fee;

  const { loading: loadingWithdraw } = useAppSelector(
    (state) => state.withdraw
  );

  const { verificationStatus } = useAppSelector((state) => state.settings);

  useEffect(() => {
    setTotal(Number(amount) - Number(fee));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount, total]);

  return (
    <div>
      <>
        {loadingWithdraw ? (
          <Spinner />
        ) : (
          <>
            {' '}
            <Title>{t('withdraw_part.final_check.title')}</Title>
            <Subtitle>
              {t('withdraw_part.final_check.subtitleULX', {
                USDT:
                  withdrawAvailabilitySteps === WithdrawAvailability.ULX
                    ? 'wULX'
                    : 'uUSDT'
              })}
            </Subtitle>
            <Info>
              <div>{t('withdraw_part.final_check.amount')}:</div>
              {parseInt(amount).toFixed(2)}{' '}
              {withdrawAvailabilitySteps === WithdrawAvailability.ULX
                ? 'wULX'
                : 'uUSDT'}
            </Info>
            <Info style={{ wordBreak: 'break-all' }}>
              <div>{t('withdraw_part.final_check.network')}:</div>{' '}
              {t('withdraw_part.final_check.ultronBlockchain')}
            </Info>
            <Info style={{ wordBreak: 'break-all' }}>
              <div>{t('withdraw_part.final_check.address')}:</div>{' '}
              {userWallets[selected].address}
            </Info>
            <Info>
              <div>{t('withdraw_part.final_check.processing_fee')}:</div> {fee}{' '}
              {withdrawAvailabilitySteps === WithdrawAvailability.ULX
                ? 'wULX'
                : 'uUSDT'}
            </Info>
            <SectionSeparator />
            <InfoRight>
              <div>{t('withdraw_part.final_check.subtotal')}:</div>
              <span>{`${parseInt(amount).toFixed(2)} ${
                withdrawAvailabilitySteps === WithdrawAvailability.ULX
                  ? 'wULX'
                  : 'uUSDT'
              }`}</span>
            </InfoRight>
            <InfoRight>
              <div>{t('withdraw_part.final_check.fee')}:</div>
              <span>
                {`${fee}`}{' '}
                {withdrawAvailabilitySteps === WithdrawAvailability.ULX
                  ? 'wULX'
                  : 'uUSDT'}
              </span>
            </InfoRight>
            <SectionSeparator />
            <InfoRight>
              <div>{t('withdraw_part.final_check.total')}:</div>
              <span>
                {`${calculatedAmountWithFee}`}{' '}
                {withdrawAvailabilitySteps === WithdrawAvailability.ULX
                  ? 'wULX'
                  : 'uUSDT'}
              </span>
            </InfoRight>
            <P3 bold color={color.colors.error500} mb='16'>
              {t('withdraw_part.final_check.infoULX')}
            </P3>
            <CheckText
              checked={checkbox}
              onClick={() => setCheckbox(!checkbox)}
              text={t('withdraw_part.final_check.confirm_txt')}
            />
            <FlexCenter style={{ flexDirection: 'column' }}>
              <Button
                maxWidth='200px'
                m={'30px 0 0 0'}
                opacity={'true'}
                disabled={!checkbox}
                onClick={() => {
                  if (!verificationStatus) {
                    setStep(8);
                  } else {
                    setStep(6);
                  }
                }}>
                {t('withdraw_part.final_check.withdrawULX')}
              </Button>
            </FlexCenter>
          </>
        )}
      </>
    </div>
  );
};
